export default __webpack_public_path__ + "static/media/meta.5337d526.png";